var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.8809,
    cy: 25.2441,
    r: 25,
    fill: "#DFAD17"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8758 16.4908C21.1672 16.2218 21.6398 16.2218 21.9312 16.4908L30.8864 24.7572C31.1778 25.0262 31.1778 25.4624 30.8864 25.7314L21.9312 33.9977C21.6398 34.2668 21.1672 34.2668 20.8758 33.9977C20.5844 33.7287 20.5844 33.2926 20.8758 33.0235L29.3033 25.2443L20.8758 17.465C20.5844 17.196 20.5844 16.7598 20.8758 16.4908Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowHome);
export default __webpack_public_path__ + "static/media/ArrowHome.ae142c7260f2445e6a7e4bb4c914055e.svg";
export { ForwardRef as ReactComponent };